import {IgnoredMessage} from '@/models';

export function ignoredMessageHandler(err, vm, info) {
  return !(err instanceof IgnoredMessage);
}
